import {Component, inject, OnInit} from '@angular/core';
import {DatePipe} from "@angular/common";
import {RouterLink} from "@angular/router";
import {DataService} from "../../services/data.service";

@Component({
    selector: 'app-price-list-list',
    imports: [RouterLink, DatePipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-table-list me-2"></i>Preislisten <small class="text-muted">({{entries?.length}})</small></h3>
                </div>

                <button type="button" class="btn btn-primary mb-3" [routerLink]="['/pricelist', 0]">Preisliste anlegen</button>

                @if (entries?.length > 0) {
                    <div class="table-responsive">
                        <table class="table table-striped table-hover mb-0 pointer">
                            <thead>
                            <tr>
                                <th style="width: 300px" (click)="setOrder('name')">
                                    Name
                                    @if (predicate == 'name') {
                                        <i class="fa-solid" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                    }
                                </th>
                                <th style="width: 150px" (click)="setOrder('currency')">
                                    Währung
                                    @if (predicate == 'currency') {
                                        <i class="fa-solid" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                    }
                                </th>
                                <th (click)="setOrder('created_at')">
                                    Erstellt am
                                    @if (predicate == 'created_at') {
                                        <i class="fa-solid" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                    }
                                </th>
                                <th (click)="setOrder('valid_from')">
                                    Gültig von
                                    @if (predicate == 'valid_from') {
                                        <i class="fa-solid" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                    }
                                </th>
                                <th (click)="setOrder('valid_to')">
                                    Gültig bis
                                    @if (predicate == 'valid_to') {
                                        <i class="fa-solid" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                    }
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (entry of entries; track entry.id) {
                                    <tr [routerLink]="['/pricelist', entry.id]">
                                        <td>{{ entry.name }}</td>
                                        <td>{{ entry.currency }}</td>
                                        <td>{{ entry.created_at | date: 'dd.MM.yyyy' }}</td>
                                        <td>{{ entry.valid_from | date: 'dd.MM.yyyy' }}</td>
                                        <td>
                                            {{ entry.valid_to | date: 'dd.MM.yyyy' }}
                                            @if (entry.valid_to == null) {
                                                <span class="text-muted">Nicht gesetzt</span>
                                            }
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>
    `
})
export class PriceListListComponent implements OnInit {

    private dataService = inject(DataService);

    entries!: any[] | null;
    predicate = 'name';
    reverse = false;

    ngOnInit(): void {
        this.listEntries();
    }

    setOrder(order: string): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.listEntries();
    }

    listEntries(): void {
        this.entries = null;
        this.dataService.request('PriceList/listAll', {
            order: this.predicate,
            reverse: this.reverse,
        }).subscribe(response => {
            this.entries = response.pricelists;
        });
    }
}
